/**
 * @description Relevant for stops on quote requests with modes AIR or FCL. An stop/address may be a door or a port (or airport)
 */
export enum RoutingStop {
  Door = "DOOR",
  Port = "PORT",
}
